// chart-race 场景模块：预览 + 编辑器 + SVG 渲染 + Remotion composition。
import type { SceneModule } from '../_shared/types'
import ChartRace from './ChartRace'
import { ChartRaceEditor } from './Editor'
import { render } from './svgRender'
import { ChartRaceComposition } from './Composition'

export const module: SceneModule = {
  id: 'chart-race',
  Component: ChartRace,
  Composition: ChartRaceComposition,
  Editor: ChartRaceEditor,
  svgRender: render,
}
